import React, { useEffect, useState } from "react";
import TopNavbar from "../../components/Gnavbar";
import { toast } from "react-toastify";
import { getRequest, putRequest } from "../../helpers/api.helper";

const EditBureauDetails = () => {
  const [loading, setLoading] = useState(false);

  const [countries, setCountries] = useState<string[]>([]);
  const [states, setStates] = useState<string[]>([]);
  const [districts, setDistricts] = useState<string[]>([]);

  const [countryModal, setCountryModal] = useState(false);
  const [stateModal, setStateModal] = useState(false);
  const [districtModal, setDistrictModal] = useState(false);

  const [countrySearch, setCountrySearch] = useState("");
  const [stateSearch, setStateSearch] = useState("");
  const [districtSearch, setDistrictSearch] = useState("");

  const [form, setForm] = useState({
    country: "India",
    state: "",
    district: "",
    location: "",
    experience_years: "",
  });

  useEffect(() => {
    getRequest("/common/country").then((res) => {
      if (Array.isArray(res)) {
        setCountries(res.map((c) => c.country).filter(Boolean));
      }
    });

    getRequest("/common/state").then((res) => {
      if (Array.isArray(res)) {
        setStates(res.map((s) => s.state).filter(Boolean));
      }
    });

    getRequest("/common/city").then((res) => {
      if (Array.isArray(res)) {
        setDistricts(res.map((d) => d.city).filter(Boolean));
      }
    });
  }, []);

  useEffect(() => {
    const fetchBureau = async () => {
      try {
        const res = await getRequest("/bureau/me");
        if (res) {
          setForm({
            country: res.data.profile.country || "India",
            state: res.data.profile.state || "",
            district: res.data.profile.district || "",
            location: res.data.profile.location || "",
            experience_years: res.data.profile.experience_years || "",
          });
        }
      } catch (error) {
        console.error("Failed to load bureau details", error);
      }
    };

    fetchBureau();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      if (!form.country || !form.state || !form.district) {
        toast.error("Please select country, state and district");
        return;
      }
      setLoading(true);
      const res = await putRequest("/bureau/me", {
        country: form.country,
        state: form.state,
        district: form.district,
        location: form.location,
        experience_years: form.experience_years,
      });
      if (res.success) {
        toast.success("Profile updated successfully");
      } else {
        toast.error(res.message || "Failed to update profile");
      }
    } catch (error) {
      toast.error("Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <TopNavbar />

      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-2xl font-semibold mb-6">Edit Business Details</h2>
          {/* Location */}
          <div className="mb-5">
            <label className="block mb-1 font-medium">
              Enter house no, flat no, street no, landmark
            </label>
            <textarea
              value={form.location}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, location: e.target.value }))
              }
              rows={4}
              className="w-full border rounded-md p-3 resize-none"
              placeholder="House no, Flat no, Street, Landmark"
            />
          </div>

          <div className="mb-4">
            <label className="block mb-1 font-medium">Country</label>
            <button
              onClick={() => setCountryModal(true)}
              className="w-full border rounded-md p-3 text-left bg-white"
            >
              {form.country || "Select country"}
            </button>
          </div>

          <div className="mb-4">
            <label className="block mb-1 font-medium">State</label>
            <button
              onClick={() => setStateModal(true)}
              className="w-full border rounded-md p-3 text-left bg-white disabled:bg-gray-100"
            >
              {form.state || "Select state"}
            </button>
          </div>

          <div className="mb-6">
            <label className="block mb-1 font-medium">District</label>
            <button
              onClick={() => setDistrictModal(true)}
              className="w-full border rounded-md p-3 text-left bg-white disabled:bg-gray-100"
            >
              {form.district || "Select district"}
            </button>
          </div>

          <div className="mb-6">
            <label className="block mb-1 font-medium">
              Experience (in years)
            </label>
            <input
              type="number"
              min="0"
              name="experience_years"
              value={form.experience_years}
              onChange={handleChange}
              placeholder="Enter years of experience"
              className="w-full border rounded-md p-3"
            />
          </div>

          <button
            onClick={handleSave}
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded"
          >
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>

      {countryModal && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-3">
          <div className="bg-white w-full max-w-md rounded-xl overflow-hidden">
            <div className="px-5 py-4 border-b flex justify-between">
              <h3 className="font-semibold">Select Country</h3>
              <button onClick={() => setCountryModal(false)}>✕</button>
            </div>

            <div className="p-4 border-b">
              <input
                value={countrySearch}
                onChange={(e) => setCountrySearch(e.target.value)}
                placeholder="Search country..."
                className="w-full border rounded-md p-2"
              />
            </div>

            <div className="max-h-64 overflow-y-auto divide-y">
              {countries
                .filter((c) =>
                  c.toLowerCase().includes(countrySearch.toLowerCase())
                )
                .map((c) => (
                  <button
                    key={c}
                    onClick={() => {
                      setForm({
                        ...form,
                        country: c,
                      });
                      setCountryModal(false);
                    }}
                    className="w-full px-4 py-3 text-left hover:bg-gray-100"
                  >
                    {c}
                  </button>
                ))}
            </div>
          </div>
        </div>
      )}

      {stateModal && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-3">
          <div className="bg-white w-full max-w-md rounded-xl overflow-hidden">
            <div className="px-5 py-4 border-b flex justify-between">
              <h3 className="font-semibold">Select State</h3>
              <button onClick={() => setStateModal(false)}>✕</button>
            </div>

            <div className="p-4 border-b">
              <input
                value={stateSearch}
                onChange={(e) => setStateSearch(e.target.value)}
                placeholder="Search state..."
                className="w-full border rounded-md p-2"
              />
            </div>

            <div className="max-h-64 overflow-y-auto divide-y">
              {states
                .filter((s) =>
                  s.toLowerCase().includes(stateSearch.toLowerCase())
                )
                .map((s) => (
                  <button
                    key={s}
                    onClick={() => {
                      setForm({
                        ...form,
                        state: s,
                      });
                      setStateModal(false);
                    }}
                    className="w-full px-4 py-3 text-left hover:bg-gray-100"
                  >
                    {s}
                  </button>
                ))}
            </div>
          </div>
        </div>
      )}

      {districtModal && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-3">
          <div className="bg-white w-full max-w-md rounded-xl overflow-hidden">
            <div className="px-5 py-4 border-b flex justify-between">
              <h3 className="font-semibold">Select District</h3>
              <button onClick={() => setDistrictModal(false)}>✕</button>
            </div>

            <div className="p-4 border-b">
              <input
                value={districtSearch}
                onChange={(e) => setDistrictSearch(e.target.value)}
                placeholder="Search district..."
                className="w-full border rounded-md p-2"
              />
            </div>

            <div className="max-h-64 overflow-y-auto divide-y">
              {districts
                .filter((d) =>
                  d.toLowerCase().includes(districtSearch.toLowerCase())
                )
                .map((d) => (
                  <button
                    key={d}
                    onClick={() => {
                      setForm({ ...form, district: d });
                      setDistrictModal(false);
                    }}
                    className="w-full px-4 py-3 text-left hover:bg-gray-100"
                  >
                    {d}
                  </button>
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditBureauDetails;
